import {ref, computed} from 'vue';

export const productsRepository = products => {
    const currentFilter = ref(null);

    const filters = [
        {title: 'Все', class: null},
        {title: '9 класс', class: 9},
        {title: 'Колледжи', class: 11},
    ];

    const displayedProducts = computed(() => {
        if (!currentFilter.value) {
            return products.value;
        }

        return products.value.filter(p => Number(p.class) === currentFilter.value);
    });

    const setFilter = type => {
        currentFilter.value = type;
    };

    return {
        displayedProducts,
        filters,
        currentFilter,
        setFilter
    };
};
